import { render, staticRenderFns } from "./FccCadastroFuncoes.vue?vue&type=template&id=746bc676"
import script from "./FccCadastroFuncoes.vue?vue&type=script&lang=js"
export * from "./FccCadastroFuncoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports